import React, { useState } from "react";
import axios from "axios";
import logo from "../images/logo.png";
import { toast } from "react-hot-toast";
import { api_url } from "../config/config";

const indianStates = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat",
  "Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh",
  "Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan",
  "Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal",
  "Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu",
  "Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry",
];

const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

const InputField = ({ label, required, error, hint, children }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-[12px] font-semibold text-[#374747] flex items-center gap-1">
      {label} {required && <span className="text-[#ff601e]">*</span>}
    </label>
    {children}
    {error && (
      <p className="text-[11px] text-red-500 flex items-center gap-1">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {error}
      </p>
    )}
    {hint && !error && <p className="text-[11px] text-[#8faba9]">{hint}</p>}
  </div>
);

const inputCls = (hasError) =>
  `w-full h-11 px-4 bg-white border-[1.5px] rounded-xl font-poppins text-[13px] text-[#1a2625] placeholder-[#8faba9] outline-none transition-all duration-200 ${
    hasError
      ? "border-red-400 focus:border-red-400 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.12)]"
      : "border-[#e2eaea] focus:border-[#1e4a46] focus:shadow-[0_0_0_3px_rgba(95,189,179,0.15)]"
  }`;

const Adresspopup = ({ onClose, fetchAddresses }) => {
  const [name,         setName]         = useState("");
  const [pincode,      setPincode]      = useState("");
  const [city,         setCity]         = useState("");
  const [state,        setState]        = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isDefault,    setIsDefault]    = useState(false);
  const [loading,      setLoading]      = useState(false);

  /* ── Validation ── */
  const nameRegex     = /^[A-Za-z\s]+$/;
  const cityRegex     = /^[A-Za-z\s]+$/;
  const addrRegex     = /^[A-Za-z0-9\s,./\-#]+$/;
  const mobileRegex   = /^\d{10}$/;
  const pincodeRegex  = /^\d{6}$/;

  const isNameValid    = nameRegex.test(name.trim());
  const isCityValid    = cityRegex.test(city.trim());
  const isAddr1Valid   = addrRegex.test(addressLine1.trim());
  const isAddr2Valid   = addressLine2.trim() === "" || addrRegex.test(addressLine2.trim());
  const isPinValid     = pincodeRegex.test(pincode);
  const isMobileValid  = mobileRegex.test(mobileNumber);
  const isFormValid    = isNameValid && isAddr1Valid && isAddr2Valid && isCityValid && isPinValid && isMobileValid && state !== "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isNameValid)   { toast.error("Name can only contain letters and spaces.");  return; }
    if (!isAddr1Valid)  { toast.error("Address Line 1 contains invalid characters."); return; }
    if (!isAddr2Valid)  { toast.error("Address Line 2 contains invalid characters."); return; }
    if (!isCityValid)   { toast.error("City can only contain letters and spaces.");   return; }
    if (!isPinValid)    { toast.error("Pin code must be exactly 6 digits.");          return; }
    if (!isMobileValid) { toast.error("Mobile number must be exactly 10 digits.");    return; }

    setLoading(true);
    try {
      await axios.post(`${api_url}/address`, {
        address_line_1: addressLine1,
        address_line_2: addressLine2,
        address_title:  name,
        pincode:        parseInt(pincode),
        city,
        state,
        mobile_number:  mobileNumber,
        is_default:     isDefault,
      }, { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } });

      onClose();
      fetchAddresses();
      toast.success("Address saved successfully!");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save address.");
    } finally {
      setLoading(false);
    }
  };

  return (
<div className="fixed inset-0 z-[9999] flex items-center justify-center px-4 font-poppins">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#0a1715]/70 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 bg-white rounded-2xl shadow-[0_24px_80px_rgba(0,0,0,0.35)] w-full max-w-[700px] max-h-[90vh] overflow-hidden flex flex-col">

        {/* ── Header ── */}
        <div className="relative bg-[#162c2a] px-6 py-5 flex-shrink-0">
          <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
            style={{ backgroundImage: plusPattern, backgroundRepeat: "repeat", backgroundSize: "40px 40px" }} />
          <div className="relative flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src={logo} alt="MediSYS" className="h-8 w-auto object-contain" />
              <div className="w-px h-6 bg-white/20" />
              <div>
                <p className="font-bold text-[15px] text-white leading-tight">Add New Address</p>
                <p className="text-[11px] text-white/45 mt-0.5">Fill in your delivery address details</p>
              </div>
            </div>
            <button onClick={onClose}
              className="w-8 h-8 rounded-xl bg-white/[0.1] hover:bg-white/[0.2] flex items-center justify-center transition-colors flex-shrink-0">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        </div>

        {/* ── Scrollable Body ── */}
        <div className="overflow-y-auto flex-1 p-6 scrollbar-hide">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">

              {/* Name */}
              <InputField label="Address Name" required error={name.trim().length > 0 && !isNameValid ? "Only letters and spaces allowed." : ""}>
                <input type="text" placeholder="Home, Office, etc." value={name}
                  onChange={(e) => setName(e.target.value.replace(/[^A-Za-z\s]/g, ""))}
                  maxLength={25} className={inputCls(name.trim().length > 0 && !isNameValid)} />
              </InputField>

              {/* Mobile */}
              <InputField label="Mobile Number" required error={mobileNumber.length > 0 && !isMobileValid ? "Must be exactly 10 digits." : ""} hint="Used for delivery communication">
                <div className="flex">
                  <div className="flex items-center gap-1.5 px-3 bg-[#f8fafa] border-[1.5px] border-r-0 border-[#e2eaea] rounded-l-xl h-11 flex-shrink-0">
                    <span className="text-[14px]">🇮🇳</span>
                    <span className="text-[13px] font-semibold text-[#374747]">+91</span>
                  </div>
                  <input type="tel" placeholder="10-digit number" value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
                    maxLength={10} inputMode="numeric"
                    className={`flex-1 h-11 px-3 bg-white border-[1.5px] rounded-r-xl outline-none text-[13px] text-[#1a2625] placeholder-[#8faba9] transition-all ${
                      mobileNumber.length > 0 && !isMobileValid
                        ? "border-red-400 focus:border-red-400"
                        : "border-[#e2eaea] focus:border-[#1e4a46] focus:shadow-[0_0_0_3px_rgba(95,189,179,0.15)]"
                    }`} />
                </div>
              </InputField>

              {/* Address Line 1 — full width */}
              <div className="sm:col-span-2">
                <InputField label="Address Line 1" required error={addressLine1.trim().length > 0 && !isAddr1Valid ? "Letters, numbers, spaces, , . / - # only." : ""}>
                  <input type="text" placeholder="Building name, Street, Area" value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value.replace(/[^A-Za-z0-9\s,./\-#]/g, ""))}
                    maxLength={120} className={inputCls(addressLine1.trim().length > 0 && !isAddr1Valid)} />
                </InputField>
              </div>

              {/* Address Line 2 — full width */}
              <div className="sm:col-span-2">
                <InputField label="Address Line 2" error={addressLine2.trim().length > 0 && !isAddr2Valid ? "Letters, numbers, spaces, , . / - # only." : ""}>
                  <input type="text" placeholder="Landmark, Nearby (optional)" value={addressLine2}
                    onChange={(e) => setAddressLine2(e.target.value.replace(/[^A-Za-z0-9\s,./\-#]/g, ""))}
                    maxLength={25} className={inputCls(addressLine2.trim().length > 0 && !isAddr2Valid)} />
                </InputField>
              </div>

              {/* City */}
              <InputField label="City" required error={city.trim().length > 0 && !isCityValid ? "Only letters and spaces allowed." : ""}>
                <input type="text" placeholder="City" value={city}
                  onChange={(e) => setCity(e.target.value.replace(/[^A-Za-z\s]/g, ""))}
                  maxLength={20} className={inputCls(city.trim().length > 0 && !isCityValid)} />
              </InputField>

              {/* Pincode */}
              <InputField label="Pin Code" required error={pincode.length > 0 && !isPinValid ? "Must be exactly 6 digits." : ""}>
                <input type="text" placeholder="6-digit pincode" value={pincode}
                  onChange={(e) => { if (/^\d{0,6}$/.test(e.target.value)) setPincode(e.target.value); }}
                  className={inputCls(pincode.length > 0 && !isPinValid)} />
              </InputField>

              {/* State — full width */}
              <div className="sm:col-span-2">
                <InputField label="State" required>
                  <select value={state} onChange={(e) => setState(e.target.value)}
                    className={`${inputCls(false)} cursor-pointer`}>
                    <option value="">Select State</option>
                    {indianStates.map((st) => <option key={st} value={st}>{st}</option>)}
                  </select>
                </InputField>
              </div>

              {/* Default address toggle — full width */}
              <div className="sm:col-span-2">
                <div className="flex items-center justify-between bg-[#f8fafa] border border-[#e2eaea] rounded-xl px-4 py-3">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1e4a46" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <p className="text-[13px] font-semibold text-[#374747]">Set as default address</p>
                      <p className="text-[11px] text-[#8faba9]">This address will be pre-selected at checkout</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    {[{ val: true, label: "Yes" }, { val: false, label: "No" }].map((opt) => (
                      <label key={String(opt.val)} className="flex items-center gap-1.5 cursor-pointer">
                        <input type="radio" name="defaultAddress" checked={isDefault === opt.val}
                          onChange={() => setIsDefault(opt.val)} className="accent-[#1e4a46] w-4 h-4" />
                        <span className="text-[13px] font-medium text-[#374747]">{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* ── Footer buttons ── */}
            <div className="flex items-center justify-end gap-3 mt-6 pt-5 border-t border-[#f1f5f5]">
              <button type="button" onClick={onClose}
                className="h-11 px-6 rounded-xl border-[1.5px] border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:bg-[#f1f5f5] hover:border-[#c5d5d4] transition-all duration-200">
                Cancel
              </button>
              <button type="submit" disabled={loading || !isFormValid}
                className="h-11 px-6 rounded-xl bg-[#162c2a] hover:bg-[#1e4a46] text-white text-[13px] font-semibold transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_2px_10px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_16px_rgba(22,44,42,0.35)] hover:-translate-y-px flex items-center gap-2">
                {loading ? (
                  <>
                    <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4"/>
                      <path className="opacity-75" fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                    Saving…
                  </>
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                      <polyline points="17 21 17 13 7 13 7 21"/>
                      <polyline points="7 3 7 8 15 8"/>
                    </svg>
                    Save Address
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Adresspopup;